module.exports = __webpack_public_path__ + "img/particle_motion_00104.16865428.png";